"use client";
import { useState, useEffect } from "react";
import { subscribe } from "diagnostics_channel";
import { Separator } from "@/components/ui/separator";
import { fetchNavigationFooterTree } from "@/utils/buildFooterTree";
import { FaXTwitter } from "react-icons/fa6";
import Image from "next/image";
import React from "react";
import { useLanguage } from "@/app/LanguageContext";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import LogoElement from "../../Element_Components/logo/logoElement";
import dataLoader from "@/utils/fetchSingleType";
import { setDefaultAutoSelectFamily } from "net";
import { getBaseUrl } from "@/lib/getBaseURL";
import Link from "next/link";
import { useTranslate } from "@/utils/languageTranslation";

interface Footer {
  footerLogo: {
    url: string;
  };
}
interface Link {
  label: string;
  href: string;
}

interface MenuCategory {
  menu: string;
  links: Link[];
}

interface FooterProps {
  logoSrc: string;
  logoAlt: string;
  menuCategories: MenuCategory[];
  socialIcons: {
    facebook?: string;
    twitter?: string;
    instagram?: string;
    linkedin?: string;
    youtube?: string;
  };
  footerLinks: Link[];
  copyright: string;
  subscribeText: string;
}

const socialIcons = {
  facebook: "https://www.facebook.com/profile.php?id=61550826170135&sk=about",
  // twitter: 'https://x.com/ETA_Ethiopia' ,
  // instagram: '#' ,
  // linkedin: '#' ,
  // youtube: '#'
};







interface SubLink {
  title: string;
  path: string;
  additionalFields: Record<string, any>;
}

interface NavLink {
  title: string;
  path: string;
  items: SubLink[];
  additionalFields: Record<string, any>;
}

const FooterTwo = () => {
  
  const {t} = useTranslate()
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'You have already Subscribe' | 'success' | 'error'>('idle');

  const { language } = useLanguage();
  const [links, setLinks] = useState<NavLink[]>([]);
  const [logo, setLogo] = useState<Footer>({ footerLogo: { url: "" } });
  const texts = {
    subscribeText:
      `${t('join_newsletter')}`,
    copyright: "2025",
  };
  
  const footerLinks = [
    { href: "#", label: `${t('privacy_policy')}` },
    { href: "#", label: `${t('terms_of_service')}` },
    { href: "#", label: `${t('cookies_settings')}` },
  ];
  useEffect(() => {
    const fetchFooterData = async () => {
      const data = await dataLoader<Footer>("site-info", language);
      setLogo(data);
    };
    fetchFooterData();
    fetchNavigationFooterTree(language)
      .then((data) => {
        //  console.log('Fetched navigation menu:', data);
        const result = data as NavLink[];
        console.log("Fetched navigation menu nav updated:", result);
        setLinks(result);
      })
      .catch((error) => {
        console.error("Error fetching navigation menu:", error);
      });
  }, []);
  const handleSubscribe = async () => {
    if (!email || !email.includes('@')) {
      alert('Please enter a valid email address.');
      return;
    }

    setStatus('loading');

    try {
      // Example: POST to your Strapi or custom API endpoint
      const res = await fetch(`${getBaseUrl()}/api/subscribers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: { email },
        }),
      });

      if (!res.ok) throw new Error('You have already subscribe!');

      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };
  return (
    <footer className="bg-[#08486C] text-gray-300 py-10 px-5 xl:px-0 ">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 w-full xl:w-[71rem]">
        {/* Logo Section */}
        <div className="col-span-2 flex items-start md:mb-5 xl:mb-0">
          <Link href="/" className="flex mx-auto w-full">
            <img src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${logo.footerLogo.url}`} alt="" className="w-[17.5rem]" />
          </Link>
        </div>

        {/* Menu Categories */}
        <div className="my-5 md:-mt-1 col-span-1 md:col-span-2 lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-4 place-items-start justify-between">
          {links.map((category) => (
            <div key={category.title} className="">
              <h3 className="text-white text-base md:text-lg text-start font-normal md:font-semibold mb-2">
                {category.additionalFields.view}
              </h3>
              <ul className="list-none p-0 m-0 text-start">
                {category.items.map((link) => (
                  <li key={link.title} className="mb-1">
                    <a
                      href={`${category.path}/${link.path}`}
                      className="hover:text-gray-400 text-white text-sm capitalize"
                    >
                      {link.additionalFields.view}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Subscribe Section */}
        <div className="col-span-2 text-start">
          <h3 className="text-white font-semibold mb-2">{}</h3>
          <p className="text-white text-sm mb-4">{texts.subscribeText}</p>
          <div className="flex gap-2 items-start flex-col sm:flex-row w-full">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('enter_your_email')}
        className="text-white border placeholder-white font-light border-white rounded-md py-2 px-3 w-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
      <button
        onClick={handleSubscribe}
        disabled={status === 'loading'}
        className="text-white font-light border-white border rounded-md py-2 px-4 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
      >
        {status === 'loading' ? 'Subscribing...' : `${t('subscribe')}`}
      </button>

      {status === 'success' && <p className="text-green-400 text-sm">Subscribed!</p>}
      {status === 'error' && <p className="text-red-400 text-sm">You have already subscribe.</p>}
    </div>
          <p className="text-white text-start text-xs mt-2">
            By subscribing you agree with our Privacy Policy and provide consent
            to receive updates from our company.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className=" py-4 mt-4 md:mt-8">
        <Separator className="w-fill xl:w-[71rem]" />

        <div className="container mt-5 mx-auto flex flex-col lg:flex-row justify-between text-xs text-gray-500 w-full xl:w-[71rem]">
          <p className="text-white px-0 mb-3 lg:mb-0">
            @ {texts.copyright} Powered by{" "}
            <a href="http://www.mint.gov.et/" className="hover:text-gray-400">
              MInT
            </a>
            . Developed by{" "}
            <a href="https://360ground.com" className="hover:text-gray-400">
              360Ground
            </a>
            . All rights reserved.
          </p>
          <ul className="list-none p-0 md:m-0 flex lg:space-x-4">
            {footerLinks.map((link) => (
              <li key={link.label}>
                <a href={link.href} className="hover:text-gray-400 text-white">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        

          
        </div>
      </div>
    </footer>
  );
};

// const FooterExample = () => {
//   const footerMenuCategories = [
//     {
//       menu: 'Government',
//       links: [
//         { label: 'About Governor', href: '#' },
//         { label: 'Mayor Of The City', href: '#' },
//         { label: 'History', href: '#' },
//         { label: 'City Cabinets', href: '#' },
//       ],
//     },
//     {
//       menu: 'Services',
//       links: [
//         { label: 'Business & Trade', href: '#' },
//         { label: 'Health Services', href: '#' },
//         { label: 'Laws & Safety Guide', href: '#' },
//         { label: 'Job Opportunities', href: '#' },
//       ],
//     },
//   ];

//   const footerSocialIcons = {
//     facebook: '#',
//     twitter: '#',
//     instagram: '#',
//     linkedin: '#',
//     youtube: '#',
//   };

//   const footerBottomLinks = [
//     { label: 'Privacy Policy', href: '#' },
//     { label: 'Terms of Service', href: '#' },
//     { label: 'Cookies Settings', href: '#' },
//   ];

//   return (
//     <div>
//       {/* Your other content */}
//       <Footer
//         logoSrc='/Flag.svg'
//         logoAlt="Kombolcha City Administration Logo"
//         menuCategories={footerMenuCategories}
//         socialIcons={footerSocialIcons}
//         footerLinks={footerBottomLinks}
//         copyright="© 2024 Relume. All rights reserved."
//         subscribeText="Join our newsletter to stay up to date on features and releases."
//       />
//     </div>
//   );
// };

// export default FooterExample;
export default FooterTwo;
